import { useEffect, useState, useRef } from "react"
import { auth, db } from "../firebase"
import { doc, getDoc, updateDoc } from "firebase/firestore"
import { useNavigate, useSearchParams } from "react-router-dom"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import rehypeRaw from "rehype-raw"
import { LuChevronLeft } from "react-icons/lu"
import "./Feed.css"

function OpportunityBlog(){

const [user,setUser] = useState(null)
const [userData,setUserData] = useState(null)
const [feedContent,setFeedContent] = useState("")
const [loading,setLoading] = useState(true)
const [fetching,setFetching] = useState(true)

const navigate = useNavigate()
const [searchParams] = useSearchParams()

const lastTickRef = useRef(null)
const bufferedSecondsRef = useRef(0)
const allowExitRef = useRef(false)

const blogId = searchParams.get("name")

const optimizeGithubImage = (src)=>{

if(!src) return src

if(src.includes("raw.githubusercontent.com")){
return src
.replace("https://raw.githubusercontent.com/","https://cdn.jsdelivr.net/gh/")
.replace("/main/","@main/")
}

if(src.includes("github.com") && src.includes("/blob/")){
return src
.replace("https://github.com/","https://cdn.jsdelivr.net/gh/")
.replace("/blob/","@")
}

return src
}

useEffect(()=>{

const init = async()=>{

const currentUser = auth.currentUser

if(!currentUser){
navigate("/login",{replace:true})
return
}

const snap = await getDoc(doc(db,"users",currentUser.uid))

if(!snap.exists()){
navigate("/dashboard",{replace:true})
return
}

setUser(currentUser)
setUserData(snap.data())
setLoading(false)

lastTickRef.current = Date.now()

}

init()

},[navigate])

useEffect(()=>{

if(!blogId) return

const fetchBlog = async()=>{

setFetching(true)

try{

const response = await fetch(
`https://raw.githubusercontent.com/sanketpadhyal/sluz-feed/main/opportunities/${blogId}`
)

if(!response.ok) throw new Error("not found")

const text = await response.text()

setFeedContent(text)

}catch{

setFeedContent("# Blog Not Available\nPlease check again later.")

}

setFetching(false)

}

fetchBlog()

},[blogId])

useEffect(()=>{

if(!user) return

const userRef = doc(db,"users",user.uid)

const saveToFirestore = async()=>{

if(!lastTickRef.current) return

const now = Date.now()
const diffSeconds = Math.floor((now-lastTickRef.current)/1000)

if(diffSeconds<=0) return

bufferedSecondsRef.current += diffSeconds
lastTickRef.current = now

if(bufferedSecondsRef.current < 30) return

const minutesToSave = bufferedSecondsRef.current/60
bufferedSecondsRef.current = 0

const todayKey = new Date().toLocaleDateString("en-CA")

const snap = await getDoc(userRef)

if(!snap.exists()) return

const data = snap.data()
const screen = data.screentime || {}

const updatedScreen = {
...screen,
[todayKey]: parseFloat(((screen[todayKey]||0)+minutesToSave).toFixed(2))
}

const updatedTotal = parseFloat(((data.totalScreenTime||0)+minutesToSave).toFixed(2))

await updateDoc(userRef,{
screentime:updatedScreen,
totalScreenTime:updatedTotal
})

setUserData(prev=>({
...prev,
screentime:updatedScreen,
totalScreenTime:updatedTotal
}))

}

const forceFlush = async()=>{

if(bufferedSecondsRef.current<=0) return

const minutesToSave = bufferedSecondsRef.current/60
bufferedSecondsRef.current = 0

const todayKey = new Date().toLocaleDateString("en-CA")

const snap = await getDoc(userRef)

if(!snap.exists()) return

const data = snap.data()
const screen = data.screentime || {}

const updatedScreen = {
...screen,
[todayKey]: parseFloat(((screen[todayKey]||0)+minutesToSave).toFixed(2))
}

const updatedTotal = parseFloat(((data.totalScreenTime||0)+minutesToSave).toFixed(2))

await updateDoc(userRef,{
screentime:updatedScreen,
totalScreenTime:updatedTotal
})

setUserData(prev=>({
...prev,
screentime:updatedScreen,
totalScreenTime:updatedTotal
}))

}

const interval = setInterval(saveToFirestore,30000)

const handleVisibilityChange = ()=>{
if(document.visibilityState==="hidden"){
forceFlush()
}else{
lastTickRef.current = Date.now()
}
}

const handleBeforeUnload = e=>{
if(!allowExitRef.current){
e.preventDefault()
e.returnValue=""
}
forceFlush()
}

document.addEventListener("visibilitychange",handleVisibilityChange)
window.addEventListener("beforeunload",handleBeforeUnload)

return()=>{
clearInterval(interval)
document.removeEventListener("visibilitychange",handleVisibilityChange)
window.removeEventListener("beforeunload",handleBeforeUnload)
}

},[user])

const handleBack = ()=>{
allowExitRef.current = true
navigate("/dashboard/explore")
}

if(loading || !userData) return null

const todayKey = new Date().toLocaleDateString("en-CA")
const todayMinutes = (userData.screentime?.[todayKey] || 0).toFixed(2)

return(

<div className="feed-page">

<button className="back-btn-fixed" onClick={handleBack}>
<LuChevronLeft/>
</button>

<div className="feed-wrapper">

<div className="feed-meta">

<h1>Opportunity Guide</h1>

<div className="feed-tags">
<span>{blogId}</span>
</div>

<p className="screen-info">
Today Screentime: {todayMinutes} minutes
</p>

</div>

<div className="feed-content">

{fetching ? (

<div className="feed-skeleton">
<div className="skeleton-title"></div>
<div className="skeleton-text"></div>
<div className="skeleton-text"></div>
<div className="skeleton-code"></div>
</div>

) : (

<ReactMarkdown
remarkPlugins={[remarkGfm]}
rehypePlugins={[rehypeRaw]}
components={{
img:({src,alt})=>(
<img
src={optimizeGithubImage(src)}
alt={alt}
loading="lazy"
decoding="async"
style={{
width: window.innerWidth <= 768 ? "150px" : "350px",
height:"auto",
display:"block",
margin:"20px auto"
}}
/>
)
}}
>
{feedContent}
</ReactMarkdown>

)}

</div>

</div>

</div>

)

}

export default OpportunityBlog